import { __assign } from "tslib";
export var ACCESS_STATUSES;
(function (ACCESS_STATUSES) {
    ACCESS_STATUSES["demo"] = "1";
    ACCESS_STATUSES["ordered"] = "2";
    ACCESS_STATUSES["content"] = "3";
})(ACCESS_STATUSES || (ACCESS_STATUSES = {}));
var viewerSite = {
    siteId: "",
    siteName: "",
};
var responseData = {
    thingEquirectangularMedia: undefined,
    images: [],
    siteName: "",
};
export var viewerData = __assign(__assign({ responseData: responseData }, viewerSite), { defaultMedia: undefined, status: undefined, previewUrl: undefined, isLoadingPreview: true });
export var viewerContext = __assign({ setViewerData: function () { } }, viewerData);
